import * as React from 'react';
import { Item, Motif } from './iMonCompte';
import {renderCol, renderImgLinkDT, renderImgLinkME} from './RenderCommon';
import { formatPrice, getShopRefInStorage } from './MonCompteAction';
import { Input } from '../inputs/Input';

interface RenderCartLineProps {
  item: Item;
  motif: Motif;
  onQuantiteChange(item: Item, qte: string): void;
  onOpenImageModal(link: any): void;
}

export class RenderCartLine extends React.Component<RenderCartLineProps, any> {
  constructor(props: RenderCartLineProps) {
    super(props);
    this.state = {
      item: this.props.item
    };
  }

  componentDidUpdate(prevProps: Readonly<RenderCartLineProps>): void {
    if (this.props.motif !== prevProps.motif) {
      let marquageIsConcerned = true;
      if(this.props.motif) {
        marquageIsConcerned = this.props.motif.marquages?.includes(this.state.item.marquage_id ?? 0);
      }

      if(!marquageIsConcerned) {
        this._onUpdateInput(0);
        const element = document.getElementById(this.state.item.idCaddies);
        if (element) {
          (element as HTMLInputElement).value = '0';
        }
      }
    }
  }

  _onUpdateInput = (value: any) => {
    this.props.onQuantiteChange(this.props.item, value);
  }

  onOpenImageModal = () => {
    const item: any = this.props.item;
    let lien = '';

    if (getShopRefInStorage() === 'ME') {
      lien = renderImgLinkME(item.creationId, item.numFrame);
    } else if (getShopRefInStorage() === 'DT' && item.marquage_id !== null) {
      lien = renderImgLinkDT(item.creationId);
    } else if (getShopRefInStorage() === 'DG' || (item.links?.images || item.links?.images_principales )) {
      if (item.links.images['1920'] && item.links.images['1920'][0]) {
        lien = item.links.images['1920'][0];
      } else if (item.links.images_principales['1920x1080']) {
        lien = item.links.images_principales['1920x1080'];
      }
    } else if (item.linksImg.images['580x580']) {
      lien = item.linksImg.images['580x580'][1].lien;
    } else if (item.linksImg.images_principales['580x580']) {
      lien = item.linksImg.images_principales['580x580'].lien;
    }

    if (lien !== '') {
      this.props.onOpenImageModal(lien);
    }
  }

  render() {

    const renderImgLink = (item: any) => {
      if (item.links.images['128x128']) {
        return item.links.images['128x128'][0];
      } else if (item.links.images_principales['128x128']) {
        return item.links.images_principales['128x128'];
      }
    };

    const renderProductImage = (item: any) => {
      let lien = '';
      let widthImg = '50';
      if (getShopRefInStorage() === 'ME') {
        widthImg = '120';
        lien = renderImgLinkME(item.creationId, item.numFrame);
      } else if (getShopRefInStorage() === 'DT'  && item.marquage_id !== null) {
        lien = renderImgLinkDT(item.creationId);
      } else if ((item.links?.images || item.links?.images_principales )) {
        lien = renderImgLink(item);
      } else if (item.linksImg.images['128x128']) {
        lien = item.linksImg.images['128x128']['1'].lien ?? item.linksImg.images['128x128'];
      } else if (item.linksImg.images['50x50']) {
        lien = item.linksImg.images['50x50'][1].lien;
      } else if (item.linksImg.images_principales['128x128']) {
        lien = item.linksImg.images_principales['128x128'].lien;
      } else if (item.linksImg.images_principales['50x50']) {
        lien = item.linksImg.images_principales['50x50'].lien;
      } else if (item.linksImg.images['200x300']) {
        lien = item.linksImg.images['200x300'][1].lien;
      } else if (item.linksImg.images_principales['200x300']) {
        lien = item.linksImg.images_principales['200x300'].lien;
      } else if (item.linksImg.images['270x270']) {
        lien = item.linksImg.images['270x270'][1].lien;
      } else if (item.linksImg.images_principales['270x270']) {
        lien = item.linksImg.images_principales['270x270'].lien;
      } else if (item.linksImg.images['550x550']) {
        lien = item.linksImg.images['550x550'][1].lien;
      } else if (item.linksImg.images_principales['550x550']) {
        lien = item.linksImg.images_principales['550x550'].lien;
      }

      return (
        <div className="col-md-3">
          <div>
            <img onClick={this.onOpenImageModal} src={lien} width={widthImg} className={'img-fluid'} style={{cursor: 'pointer'}}/>
          </div>
        </div>
      );
    };

    const renderProductImg = (item: any) => {
      return (
        <div>
          {renderProductImage(item)}
        </div>
      );
    };

    const renderQteDejaRetournee = () => {
      if (this.state.item.qteDejaRetourne > 0) {
        return (
          <div className="mt-2">
            <p className="small">
              Une demande de {this.state.item.qteDejaRetourne} article(s) est déjà en cours de traitement. </p>
          </div>
        );
      }
    };

    const renderQteImpactee = (marquageIsConcerned: boolean) => {
      return (
        <div>
          <div>
            <Input id={this.state.item.idCaddies} type="number" className="quantiteImpactee w30" name={this.state.item.idCaddies} disabled={!marquageIsConcerned}
                   onChange={this._onUpdateInput} min={0} delay={400}
                   max={Number(this.state.item.Quantite) - this.state.item.qteDejaRetourne}
                   value={this.state.item.quantiteImpactee || 0}/>
            &nbsp;/ {this.state.item.Quantite}
          </div>
          {renderQteDejaRetournee()}
        </div>
      );
    };

    const renderTittre = () => {
      if (getShopRefInStorage() === 'DG') {
        return this.state.item.titles.fr;
      } else  if (getShopRefInStorage() === 'DT' && this.state.item.dimensions && this.state.item.dimensions.largeur && this.state.item.dimensions.hauteur) {
        return (
          <>
            <div className={'text-left'}>
              {this.state.item.Titre}
            </div>
            <div className={'small text-left'}>
              {this.state.item.dimensions.largeur + 'cm x '+this.state.item.dimensions.hauteur + 'cm'}
            </div>
          </>
        );
      } else if(getShopRefInStorage() !== 'MT') {
        return (
          <>
            <div>
              {this.state.item.Titre}
            </div>
            {this.state.item.marquage && this.state.item.surfaces && <div className="d-block small">
              <p className="m-0 p-0"><span className="colorOpac">Surfaces : </span>{this.state.item.surfaces}</p>
              <p className="m-0 p-0"><span className="colorOpac">Marquage : </span>{this.state.item.marquage}</p>
            </div>}
          </>
        );
      } else {
        return this.state.item.Titre;
      }
    };

    const renderItem = () => {
      const ref = getShopRefInStorage();

      let marquageIsConcerned = true;
      if(this.props.motif) {
        marquageIsConcerned = this.props.motif.marquages?.includes(this.state.item.marquage_id ?? 0);
      }

      return (
        <>
          {!marquageIsConcerned && 
            <div className="lignePanierNotConcernedSav">
              <span>Ce motif n'est pas compatible avec cette ligne de votre panier</span>
            </div>
          }
          <div className={`d-flex flex-row justify-content-between row-cart-line align-items-center `}
              title={marquageIsConcerned ? '' : "Cette ligne n'est pas concernée par ce motif de retour"}>
            {renderCol(renderProductImg(this.state.item), '1 col-2 p-0 imgReclamation')}
            <div className="col-md-7 col-5 d-flex align-items-center p-0 pl-1">
              {renderCol(renderTittre(), '5 reclamLabelTitre pa0Mobile')}
              {ref != 'DT' &&
              <>
                {renderCol(this.state.item.reference_visible, '3 pa0 reclamLabelReference pa0Mobile')}
                {renderCol(this.state.item.Couleur, '2 reclamLabelCouleur pa0Mobile')}
              </>
              }
              {getShopRefInStorage() !== 'ME' && getShopRefInStorage() !== 'DT' ? (
                renderCol(this.state.item.taille, '2 reclamLabelTaille pa0Mobile')
              ) : (
                renderCol('', '2 pa0Mobile')
              )
              }
            </div>
            <div className="col-md-4 col-5 d-flex align-items-center p-0 pr-1">
              {renderCol(renderQteImpactee(marquageIsConcerned), '8 col-lg-7 reclamLabelQuantite pa0Mobile')}
              {renderCol(formatPrice(Number(this.state.item.prixUnitaire).toFixed(2)) + ' €', '4 col-lg-5 pr-0' +
                ' reclamLabelPrix pa0Mobile')}
            </div>
          </div>
        </>
      );
    };

    return renderItem();
  }
}
